module.exports = "/_next/static/images/yoav-gray-abe0192d6335c58a804f64f0c94be4ee.jpg";